"use client"

import { useState } from "react"
import styles from "./FAQComponent.module.css"

// Iconos SVG inline para evitar dependencias externas
const HelpCircleIcon = () => (
  <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
    <point cx="12" cy="17" r="0.01" />
  </svg>
)

const DollarSignIcon = () => (
  <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
)

const FileTextIcon = () => (
  <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14,2 14,8 20,8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10,9 9,9 8,9" />
  </svg>
)

const ClockIcon = () => (
  <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12,6 12,12 16,14" />
  </svg>
)

const UsersIcon = () => (
  <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
)

const ShieldIcon = () => (
  <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
)

const MapIcon = () => (
  <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" />
    <line x1="9" y1="3" x2="9" y2="18" />
    <line x1="15" y1="6" x2="15" y2="21" />
  </svg>
)

const CheckCircleIcon = () => (
  <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22,4 12,14.01 9,11.01" />
  </svg>
)

const ChevronDownIcon = () => (
  <svg className={styles.chevron} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="6,9 12,15 18,9" />
  </svg>
)

const FAQComponent = () => {
  const [openItems, setOpenItems] = useState({})

  const toggleItem = (itemId) => {
    setOpenItems((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }))
  }

  // Función para abrir WhatsApp
  const handleContactWhatsApp = () => {
     const phoneNumber = "573102646177" // Número sin espacios ni caracteres especiales
    const message = encodeURIComponent("Hola, ¿cómo podemos colaborarte?")
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${message}`
    window.open(whatsappURL, "_blank")
  }

  const faqData = [
    {
      id: "item-1",
      icon: <HelpCircleIcon />,
      iconColor: styles.iconBlue,
      question: "¿Qué hacen exactamente en Defensa Financiera S.A.S.?",
      answer:
        "Nos especializamos en realizar todas las gestiones legales y administrativas para reclamar saldos a su favor que puedan existir en entidades públicas o privadas, como bancos, aseguradoras o fiduciarias, supervisadas por la Superintendencia Financiera de Colombia. Nuestro objetivo es garantizar que usted, ya sea como titular, beneficiario o heredero, pueda acceder a los derechos y al dinero que legalmente le corresponde.",
    },
    {
      id: "item-2",
      icon: <FileTextIcon />,
      iconColor: styles.iconGreen,
      question: "¿Qué tipo de acciones legales realizan?",
      answer:
        "Nuestro servicio es integral. Incluye desde la presentación de derechos de petición y acciones de tutela, hasta la representación en procesos administrativos y judiciales si es necesario. Nos encargamos de redactar y presentar todos los documentos legales requeridos para defender y materializar sus derechos.",
    },
    {
      id: "item-3",
      icon: <MapIcon />,
      iconColor: styles.iconPurple,
      question: "¿Necesito estar en Manizales para contratarlos?",
      answer:
        "No. Aunque nuestra sede principal está en Manizales, adelantamos todas las gestiones desde nuestra ciudad utilizando herramientas tecnológicas y los canales de justicia digital. Atendemos casos en todo el territorio nacional sin que usted tenga que desplazarse.",
    },
    {
      id: "item-4",
      icon: <UsersIcon />,
      iconColor: styles.iconOrange,
      question: "¿Quiénes pueden solicitar sus servicios?",
      answer:
        "Cualquier persona que crea tener derecho a reclamar un saldo a su favor, ya sea como titular directo de la cuenta o producto, como beneficiario designado en una póliza o contrato, o como heredero de una persona fallecida que tenía dichos saldos.",
    },
    {
      id: "item-5",
      icon: <ClockIcon />,
      iconColor: styles.iconRed,
      question: "¿Cómo funciona el proceso una vez los contrato?",
      answer:
        "Una vez firma el contrato, iniciamos el proceso: 1. Verificación: Investigamos y confirmamos la existencia de saldos a su favor. 2. Gestión: Recopilamos los documentos necesarios y adelantamos todas las actuaciones legales (derechos de petición, demandas, etc.) para que la entidad reconozca su derecho. 3. Consolidación: Trabajamos hasta que la entidad emite el 'título valor' (cheque, resolución, etc.) que representa el dinero a su favor. 4. Cobro: Usted, como titular del derecho, es quien recibe el dinero directamente de la entidad financiera.",
    },
    {
      id: "item-6",
      icon: <FileTextIcon />,
      iconColor: styles.iconIndigo,
      question: "¿Qué documentos necesito para iniciar el proceso?",
      answer:
        "Principalmente, deberá otorgarnos poderes especiales autenticados para poder representarlo ante las entidades. Nosotros nos encargamos de redactarlos y le indicaremos cuándo y dónde autenticarlos. Además, se podrían necesitar documentos como registros civiles (de nacimiento, matrimonio o defunción) y escrituras públicas de sucesión, dependiendo del caso.",
    },
    {
      id: "item-7",
      icon: <ShieldIcon />,
      iconColor: styles.iconTeal,
      question: "¿Qué pasa si soy heredero y se necesita un proceso de sucesión?",
      answer:
        "Si para reclamar los saldos se requiere adelantar una sucesión notarial, no se preocupe. Nuestro servicio y los honorarios pactados ya incluyen la gestión de este trámite sin costos adicionales de honorarios para usted.",
    },
    {
      id: "item-8",
      icon: <DollarSignIcon />,
      iconColor: styles.iconCyan,
      question: "¿Cuánto cuestan sus servicios?",
      answer:
        "Nuestros honorarios corresponden al 30% del valor que usted reciba efectivamente. Lo más importante es que solo cobramos si usted gana. Si no logramos que le paguen, usted no nos debe nada por concepto de honorarios.",
    },
    {
      id: "item-9",
      icon: <DollarSignIcon />,
      iconColor: styles.iconPink,
      question: "¿Tengo que pagarles algo por adelantado?",
      answer:
        "No. No cobramos adelantos por nuestros honorarios. El pago de nuestros servicios se realiza únicamente después de que la entidad le haya reconocido el dinero y usted lo haya cobrado.",
    },
    {
      id: "item-10",
      icon: <CheckCircleIcon />,
      iconColor: styles.iconAmber,
      question: "¿Quién recibe el dinero reclamado?",
      answer:
        "Para garantizar total transparencia, usted siempre recibirá el dinero directamente de la entidad financiera. Nosotros no estamos autorizados para recibir los fondos en su nombre. Una vez usted reciba el pago, se coordina la transferencia de nuestros honorarios.",
    },
    {
      id: "item-11",
      icon: <FileTextIcon />,
      iconColor: styles.iconGreen,
      question: "¿Existen otros gastos además de los honorarios?",
      answer:
        "Sí. Los honorarios no incluyen los 'gastos necesarios' para el proceso. Estos gastos, como el costo de las copias auténticas de registros civiles o escrituras que exija la entidad, deben ser asumidos por usted. Sin embargo, si es necesario, podemos cubrirlos temporalmente y usted nos los reembolsará al final del proceso, con los debidos soportes.",
    },
    {
      id: "item-12",
      icon: <ShieldIcon />,
      iconColor: styles.iconBlue,
      question: "¿Mi información personal está segura con ustedes?",
      answer:
        "Absolutamente. Toda la información y los documentos que nos proporciona son tratados con estricta confidencialidad. Nos comprometemos a proteger sus datos personales y a utilizarlos únicamente para los fines del proceso de reclamación, cumpliendo con la ley de protección de datos de Colombia.",
    },
    {
      id: "item-13",
      icon: <CheckCircleIcon />,
      iconColor: styles.iconRed,
      question: "¿Qué pasa si el proceso no tiene éxito?",
      answer:
        "Como trabajamos bajo un modelo de éxito, si por alguna razón no es posible consolidar su derecho y usted no recibe ningún pago, no tendrá que pagarnos honorarios. El riesgo lo asumimos nosotros.",
    },
  ]

  return (
    <div className={styles.container}>
      {/* Header Section */}
      <div className={styles.header}>
        <div className={styles.badge}>Preguntas Frecuentes</div>
        <h1 className={styles.title}>¿Tienes dudas sobre nuestros servicios?</h1>
        <p className={styles.subtitle}>
          Encuentra respuestas a las preguntas más comunes sobre la recuperación de saldos a favor y nuestros servicios
          de asesoría legal especializada.
        </p>
      </div>

      {/* FAQ Section */}
      <div className={styles.faqCard}>
        <div className={styles.faqHeader}>
          <h2 className={styles.faqTitle}>
            <HelpCircleIcon />
            Preguntas Frecuentes
          </h2>
        </div>
        <div className={styles.faqContent}>
          <div className={styles.accordion}>
            {faqData.map((faq) => (
              <div key={faq.id} className={styles.accordionItem}>
                <button
                  className={styles.accordionTrigger}
                  onClick={() => toggleItem(faq.id)}
                  aria-expanded={openItems[faq.id] || false}
                >
                  <div className={styles.questionContainer}>
                    <div className={`${styles.iconContainer} ${faq.iconColor}`}>{faq.icon}</div>
                    <span className={styles.questionText}>{faq.question}</span>
                  </div>
                  <div className={`${styles.chevronContainer} ${openItems[faq.id] ? styles.chevronOpen : ""}`}>
                    <ChevronDownIcon />
                  </div>
                </button>
                <div className={`${styles.accordionContent} ${openItems[faq.id] ? styles.accordionContentOpen : ""}`}>
                  <div className={styles.answerText}>{faq.answer}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className={styles.ctaCard}>
        <div className={styles.ctaContent}>
          <h3 className={styles.ctaTitle}>¿No encontraste la respuesta que buscabas?</h3>
          <p className={styles.ctaSubtitle}>
            Nuestro equipo de expertos está listo para ayudarte con una consulta personalizada
          </p>
          <div className={styles.ctaButtonsCenter}>
            <button className={styles.primaryButton} onClick={handleContactWhatsApp}>
              Contactar Ahora
            </button>
            {/* <button className={styles.secondaryButton}>Verificar Saldos Gratis</button> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FAQComponent